const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Connection: 'keep-alive',
};
/* istanbul ignore next */
function _getToken() {
  const token = sessionStorage.getItem('token');
  /* istanbul ignore next */
  if (token) headers['token-process'] = `${token}`;

  return token;
}
/* istanbul ignore next */
function _processResponse(result) {
  return result
    .then((res) => res.json())
    .then(async (res) => {
      let _res = res;

      if (!res?.data) _res = { error: res?.error, data: res?.data };
      else if (res?.data?.error) _res = { error: res.data.error };

      return _res;
    })
    .catch((error) => {
      return { error };
    });
}
/* istanbul ignore next */
async function _processesRequest(request, method, params, optionalsHeaders) {
  _getToken();

  const response = fetch(request, {
    method,
    /* istanbul ignore next */
    headers: optionalsHeaders ? { ...headers, ...optionalsHeaders } : headers,
    ...(params ? { body: JSON.stringify({ params }) } : {}),
  });

  const result = await _processResponse(response);
  return result;
}
/* istanbul ignore next */
const api = (urlBase) => ({
  async get(endpoint, params = null, optionalsHeaders = null) {
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'GET',
      params,
      optionalsHeaders
    );
    return result;
  },
  /* istanbul ignore next */
  async post(endpoint, params = null, optionalsHeaders = null) {
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'POST',
      params,
      optionalsHeaders
    );
    return result;
  },
  /* istanbul ignore next */
  async put(endpoint, params = null, optionalsHeaders = null) {
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'PUT',
      params,
      optionalsHeaders
    );
    return result;
  },
  /* istanbul ignore next */
  async delete(endpoint, params = null, optionalsHeaders = null) {
    const result = await _processesRequest(
      `${urlBase}${endpoint}`,
      'GET',
      params,
      optionalsHeaders
    );
    return result;
  },
});

export default api;
